module.exports = __webpack_public_path__ + "static/media/myLogoName.61f22be7.jpg";